import { IWorkgroupState } from '@/store/workgroup';
import { IWorkgroupGetters } from './getters.types';
import { IWorkgroup, Workgroup } from '@/models';

export const getters: IWorkgroupGetters = {
  getWorkgroups(state: IWorkgroupState): IWorkgroup[] {
    return state.workgroups.map(data => new Workgroup(data));
  },

  getWorkgroupById: (state: IWorkgroupState) => (
    id: number
  ): IWorkgroup | undefined => {
    const data = state.workgroups.find(workgroup => workgroup.id === id);
    if (!data) {
      return undefined;
    }

    return new Workgroup(data);
  }
};
